// TODO(@Kanishk): Shift to @cleartrip/ct-design

import React, { PropsWithChildren } from "react";
import classNames from "classnames";

import { normalizeSize } from "src/utils/uiHelpers";

import "./Stencil.scss";

interface IStencilProps {
  /**
   * Additional classes to be added to the component
   */
  className?: string;
  /**
   * Height of the stencil
   */
  height: string | number;
  /**
   * Width of the stencil
   */
  width: string | number;
  /**
   * Either a block or inline
   */
  type?: string;
  /**
   * Adds a shimmer to the placeholders
   */
  shimmer?: boolean;
  /**
   * Invert colors of stencil for dark backgrounds
   */
  dark?: boolean;
}

const Stencil = (props: PropsWithChildren<IStencilProps>) => {
  const {
    children = null,
    className = "",
    height = "100",
    width = "100",
    type = "block",
    shimmer = false,
    dark = false,
  } = props;
  const styles = {
    width: normalizeSize(width),
    height: normalizeSize(height),
  };
  const classes = classNames(className, {
    Stencil: true,
    "has-shimmer": shimmer,
    "is-rounded": type === "rounded",
    "is-circular": type === "circular",
    "is-dark": dark === true,
  });

  return (
    <div className={classes} style={styles}>
      {children}
    </div>
  );
};

export { Stencil };
